'use client';
import parse from 'html-react-parser';

type EmbedButton = {
  embedButton?: string | null;
};

export default function EmbedButton({ embedButton }: EmbedButton) {
  if (!embedButton) {
    return;
  }
  return <>{parse(embedButton)}</>;
}
